import PageLoader from '@ui_components/PageLoader';
import { getCookie } from '@utility/cookies';
import getTokenDetails from '@utility/getTokenDetails';
import validateOrganizationName from '@utility/validateOrganizationName';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const MainContainer = dynamic(() => import('@containers/MainContainer'), { loading: () => <PageLoader /> });

type HomeComponentProps = {
    tokenDetails: TokenDetailsProps
}

const HomePage = ({ tokenDetails }: HomeComponentProps) => {
    const router = useRouter()
    return (
        <MainContainer defaultPage="login" tokenDetails={tokenDetails} organizationName={String(router?.query?.organizationName)} />
    );
}

const decodeRedirectDashToken = (redirectDashToken: string | undefined): { accessToken: string } | null => {
    if (!redirectDashToken) {
        return null;
    }
    try {
        const decodedString = Buffer.from(redirectDashToken, 'base64').toString('utf-8');
        return JSON.parse(decodedString);
    } catch (error) {
        console.log("invilaid redirectDashToken", error);
        return null;
    }
}

export const getServerSideProps: GetServerSideProps = async ({ req, params, query }) => {

    const organizationName = params?.organizationName as string
    if (validateOrganizationName(organizationName)) {
        const cookies = (req.headers.cookie || "")
        const tokenFromRedirectDashToken = decodeRedirectDashToken(query?.redirectDashToken as string);
        const accessToken = String(tokenFromRedirectDashToken?.accessToken || query?.token || (query?.embed ? "" : (getCookie("access_token", cookies) || "")));
        const tokenDetails = await getTokenDetails(accessToken)
        return {
            props: {
                tokenDetails
            },
        };
    }
    else {
        return {
            notFound: true
        }
    }
};

export default HomePage
